<template>
    <div class="margin-vertical-s-10 xmoMarketingHubPage__search">
        <OutlookMarketingSearch
            :locale="locale"
            :filter-form="filterForm"
            :icons="icons"
            :base-path="basePath"
            :form-name="formName"
            :show-popular-markets="true"
            :request-path="'outlookHighlightsSearchAjax'"
            :placeholder="getPlaceholderString(marketDirectory.children[0].name)"
            :is-highlights-header="true"
            :popular-markets="getPopularMarkets">
            <template #quickstart-header>
                <h4 class="text-color--dark-blue-gray margin-left-20 marketingHubPage__resultsHeader">
                    {{ generateMarketName(marketDirectory.name) }}
                </h4>
            </template>
            <template #quickstart>
                <HighlightMarkets
                    :icons="icons"
                    :main-market="generateMarketName(marketDirectory.name)"
                    :quick-start-items="getQuickstartItems" />
                <template>
                    <div class="highlights--footer linkArrowHover">
                        {{ trans('XMO_HIGHLIGHTS_UNDERSTAND_MARKETS') }}
                        <a
                            :href="getPath('outlookHubPage')"
                            role="menuitem"
                            data-gtm="xmoHighlights__mainMarketsLink">
                            {{ trans('XMO_HIGHLIGHTS_VISIT_MARKET') }}
                            <svg
                                aria-hidden="true"
                                class="stat__svgIcon margin-left-5">
                                <use href="#iconArrowRightLongBold" />
                            </svg>
                        </a>
                    </div>
                </template>
            </template>
            <template #results="slotProps">
                <HighlightResults
                    :icons="icons"
                    :matched-search-results="slotProps.matchedSearchResults" />
            </template>
        </OutlookMarketingSearch>
    </div>
</template>

<script>
    import Translator from 'tools/trans';
    import OutlookMarketingSearch from 'outlook/components/outlookMarketingSearch';
    import HighlightMarkets from 'outlook/components/marketHighlights/highlightMarkets';
    import HighlightResults from 'outlook/components/marketHighlights/highlightResults';
    import { generateMarketName } from 'outlook/utils/generateMarketName';
    import { isMobile } from 'tools/isMobile';
    import { getPath } from 'tools/getFromHtml';
    import { HIGHLIGHTS_POPULAR_MARKETS } from 'outlook/constants/constants';
    import { mapState } from 'vuex';

    const MAX_PLACEHOLDER_LENGTH_MOBILE = 34;

    export default {
        components: {
            OutlookMarketingSearch,
            HighlightMarkets,
            HighlightResults,
        },
        props: {
            marketData: { type: Object, required: true },
            marketDirectory: { type: Object, required: true },
            imageLocale: { type: String, required: true },
            locale: { type: String, required: true },
            filterForm: { type: Object, required: true },
            icons: { type: Object, required: true },
            formName: { type: String, required: true },
        },
        computed: {
            ...mapState([
                'basePath',
            ]),
            getPopularMarkets() {
                return HIGHLIGHTS_POPULAR_MARKETS[this.marketDirectory?.name];
            },
            getQuickstartItems() {
                return this.marketDirectory.children.map(market => {
                    return { shortTitle: this.marketDirectory.name, teaser: '', name: market.name, slug: market.slug };
                });
            },
        },
        methods: {
            trans: Translator.trans,
            isMobile,
            getPath,
            generateMarketName,
            getPlaceholderString(marketName) {
                const placeholder = `${ Translator.trans('HIGHLIGHTS_SEARCH_PLACEHOLDER') } ${ marketName }`;
                if (this.isMobile() && placeholder.length > MAX_PLACEHOLDER_LENGTH_MOBILE) {
                    return `${ placeholder.slice(0, MAX_PLACEHOLDER_LENGTH_MOBILE) }...`;
                }

                return placeholder;
            },
        },
        mounted() {
            this.$store.commit('SET_CURRENT_OUTLOOK', this.marketDirectory.name.toLocaleUpperCase());
        },
    };
</script>
